import * as React from 'react'

const ArrowUp = props => {
  return (
    <svg width={20} height={12} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10l1.393 1.435L9 3.828V20h2V3.828l7.586 7.586L20 10 10 0 0 10z"
        fill="#304A3D"
      />
    </svg>
  )
}

export default ArrowUp
